<template>
  <div ref="uploadContainer" class="upload-container">
    <!-- Existing / Dummy Image Preview -->
    <div class="preview">
      
      <img
        :src="previewImage"
        :alt="'Signature'"
        :width="displayWitdh"
        :height="displayHeight"
        class="border"
      />
      

      <!-- Upload Button -->
      <div v-if="signatureEditable != 0" class="actions mt-3">
        <b-button variant="primary btn-sm" @click="$bvModal.show('signatureModal')">
          <i class="fa fa-upload"></i> {{ buttonLabel }}
        </b-button>
      </div>
    </div>

    <!-- BootstrapVue Modal -->
    <b-modal
      id="signatureModal"
      title="Upload Signature"
      hide-footer
      centered
      @hidden="resetModal"
    >
      <ul class="instructions">
        <li>📏 Signature Image dimension must be exactly <b>{{ requiredWidth }}x{{ requiredHeight }} px</b></li>
        <li>🧾 Maximum file size: <b>{{ maxSizeKB }} KB</b></li>
        <li>🖼️ Accepted formats: <b>JPEG / PNG</b></li>
        <li>🎨 For best results, use a clear signature with transparent background.</li>
      </ul>

      <!-- File Input -->
      <div class="file-input mt-3 text-center">
        <label class="upload-label btn btn-outline-primary" for="fileInput">
          <i class="fa fa-image"></i> Choose Image
        </label>
        <input
          id="fileInput"
          ref="fileInput"
          type="file"
          accept="image/*"
          @change="onFileChange"
          hidden
        />
      </div>

      <!-- Preview -->
      <div v-if="selectedPreview" class="preview mt-3 text-center">
        <img
          :src="selectedPreview"
          :alt="'Selected Image'"
          width="300"
          height="50"
          class="border"
        />
      </div>

      <!-- Error -->
      <p v-if="errorMessage" class="text-danger mt-2 text-center">{{ errorMessage }}</p>

      <!-- Actions -->
      <div class="actions mt-4 d-flex justify-content-center gap-2">
        <b-button
          variant="primary"
          @click="uploadImage"
          :disabled="!selectedFile || isUploading"
        >
          <i class="fa fa-upload"></i>
          {{ isUploading ? 'Uploading...' : 'Upload' }}
        </b-button>
        <b-button variant="secondary btn btn-sm" @click="$bvModal.hide('signatureModal')">Cancel</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { POST } from "@/utils/Request";
import { UPLOAD_SIGNATURE } from "@/const/api";

export default {
  name: "SignatureUploadModal",
  props: {
    displayWitdh: { type: Number, default: 300 },
    displayHeight: { type: Number, default: 50 },
    existingImage: { type: String, default: "" },
    buttonLabel: { type: String, default: "Upload Signature" },
    maxSizeKB: { type: Number, default: 200 },
    requiredWidth: { type: Number, default: 300 },
    requiredHeight: { type: Number, default: 300 },
    signatureEditable: { type: Number, default: 0 },
  },
  data() {
    return {
      selectedFile: null,
      selectedPreview: null,
      errorMessage: "",
      isUploading: false,
      cacheBuster: Date.now(),
    };
  },
  watch: {
    existingImage(newVal) {
      this.cacheBuster = Date.now();
    },
  },
  computed: {
    previewImage() {
      return (
        this.existingImage
      ? `${this.existingImage}?v=${this.cacheBuster}`
      : process.env.VUE_APP_API_URL+'/dist/img/signature.png'
      );
    },
  },
  methods: {
    resetModal() {
      this.selectedFile = null;
      this.selectedPreview = null;
      this.errorMessage = "";
      this.isUploading = false;
    },
    async onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      // if (!file.type.startsWith("image/")) {
      //   this.errorMessage = "Please select a valid image file!";
      //   return;
      // }

      // if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      //   this.errorMessage = "Only PNG or JPEG images are allowed!";
      //   return;
      // }

      // if (file.size / 1024 > this.maxSizeKB) {
      //   this.errorMessage = `File too large! Max allowed size is ${this.maxSizeKB} KB.`;
      //   return;
      // }

      // const { width, height } = await this.getImageDimensions(file);
      // if (width !== this.requiredWidth || height !== this.requiredHeight) {
      //   this.errorMessage = `Image must be exactly ${this.requiredWidth}x${this.requiredHeight}px.`;
      //   return;
      // }

      // 1ï¸âƒ£ Validate type first
        const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
          this.errorMessage = "Invalid file type. Only PNG or JPEG images are allowed!";
          this.selectedFile = null;
          this.selectedPreview = null;
          return;
        }

        // 2ï¸âƒ£ Validate file size
        const maxKB = this.maxSizeKB;
        if (file.size / 1024 > maxKB) {
          this.errorMessage = `File too large! Maximum allowed size is ${maxKB} KB.`;
          this.selectedFile = null;
          this.selectedPreview = null;
          return;
        }

        // 3ï¸âƒ£ Validate image dimensions
        try {
          const { width, height } = await this.getImageDimensions(file);
          if (width !== this.requiredWidth || height !== this.requiredHeight) {
            this.errorMessage = `Image must be exactly ${this.requiredWidth}x${this.requiredHeight}px. Your image is ${width}x${height}px.`;
            this.selectedFile = null;
            this.selectedPreview = null;
            return;
          }
        } catch (err) {
          this.errorMessage = "Failed to read image dimensions. Please try another image.";
          this.selectedFile = null;
          this.selectedPreview = null;
          return;
        }

      // âœ… If all checks pass
      this.errorMessage = "";
      this.selectedFile = file;
      this.selectedPreview = URL.createObjectURL(file);
    },
    getImageDimensions(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve({ width: img.width, height: img.height });
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
      });
    },
    async uploadImage() {
      if (!this.selectedFile) {
        this.errorMessage = "Please select an image before uploading.";
        return;
      }

      const formData = new FormData();
      formData.append("signature", this.selectedFile);

      this.isUploading = true;
      try {
        const response = await POST(UPLOAD_SIGNATURE, formData);
        if (response.status === 200) {
          const newUrl = response.data.url;
          this.$emit("uploaded", {"status":response.data.status,"url":newUrl});
          // Update preview immediately to new server image
          this.selectedPreview = newUrl;
          this.cacheBuster = Date.now();
          this.$iziToast.success({ message: "Signature Uploaded Successfully!" });
          this.$bvModal.hide("signatureModal");
        } else {
          this.errorMessage =
            response.message || "Upload failed. Please try again.";
        }
      } catch (error) {
        console.error(error);
        this.errorMessage = "Upload failed. Please try again.";
      } finally {
        this.isUploading = false;
      }
    },
  },
};
</script>

<style scoped>
.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview img {
  /*border-radius: 50%;*/
  border: 1px solid #ddd;
  /*object-fit: cover;*/
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
}
.preview img:hover{
  transform: scale(1.05);
}


.actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.instructions {
  font-size: 0.95rem;
  line-height: 1.4;
  color: #444;
  background: #f8f8ff;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-bottom: 15px;
  list-style-type: none;
}
.upload-label {
  cursor: pointer;
}
</style>